import { EncomendaStatusEnum } from "core/features/encomenda/typings";

export function getProgressForEvent(event: EncomendaStatusEnum | undefined) {
  switch (event) {
    case EncomendaStatusEnum.EntregueAoMorador:
      return 75;
    case EncomendaStatusEnum.RecebidaNaPortaria:
    case EncomendaStatusEnum.RecebidaNaSalaDeEncomendas:
      return 50;
    case EncomendaStatusEnum.EntregaConfirmadaPeloMorador:
      return 100;
    case EncomendaStatusEnum.AguardandoRecebimento:
      return 0;
    default:
      return 0;
  }
}
